import React, { useState, useRef } from "react";
import 'react-modern-drawer/dist/index.css';
import { HiDevicePhoneMobile } from "react-icons/hi2";
import { VscFeedback } from "react-icons/vsc";
import { IoKeyOutline } from "react-icons/io5";
import { TbFolderQuestion } from "react-icons/tb";
import { TbCube3dSphere } from "react-icons/tb";
import banner from '../../../images/banner.png';
import { BrowserView, MobileView } from 'react-device-detect';
import emailjs from '@emailjs/browser';

const SettingsPanel = ({
    globalRefs,
    globalState,
}) => {

    const [isInTabs, setIsInTabs] = useState(true);

    const [ulist, setUlist] = useState([]);

    const [isInAccountSettings, setIsInAccountSettings] = useState(false);

    const [isMapViewActive, setIsMapViewActive] = useState(false);

    const [feedback, setFeedback] = useState('');

    const [feedbackAttempted, setFeedbackAttempted] = useState(false);
    const [feedBackSuccess, setFeedBackSuccess] = useState(false);
    const [feedbackMessage, setFeedbackMessage] = useState('');

    let userEmail = globalState.userEmail;

    const openAccountSettings = () => {
        reset();
        setIsInAccountSettings(true);
        setIsInTabs(false);
        // window.location.href = 'https://api.staging.skylark.entsys.uk/change';
    }

    const goToChangePasswordPage = () => {
        window.location.href = 'https://api.staging.skylark.entsys.uk/change';
    }

    // Account Settings

    const [user, setUser] = useState(null);

    const [isEditingPassword, setIsEditingPassword] = useState(false);
    const [newPassword, setNewPassword] = useState("");

    // Users

    const [isInUsers, setIsInUsers] = useState(false);

    const openUsers = () => {
        reset();
        setIsInUsers(true);
    }

    // Saved Files

    const [isInSavedFiles, setIsInSavedFiles] = useState(false);

    // Shared Files

    const [isInSharedFiles, setIsInSharedFiles] = useState(false);

    const openSharedFiles = () => {
        reset();
        setIsInSharedFiles(true);
    }

    // Instructions

    const [isInInstructions, setIsInInstructions] = useState(false);

    const openInstructions = () => {
        reset();
        setIsInInstructions(true);
    }

    // User Feedback

    const [isInUserfeedback, setIsInUserfeedback] = useState(false);

    const openUserfeedback = () => {
        reset();
        setIsInUserfeedback(true);
    }

    // Support

    const [isInSupport, setIsInSupport] = useState(false);

    const openSupport = () => {
        reset();
        setIsInSupport(true);
    }

    const reset = () => {
        setIsInAccountSettings(false);
        setIsInUsers(false);
        setIsInSavedFiles(false);
        setIsInTabs(false);
        setIsInSharedFiles(false);
        setIsInInstructions(false);
        setIsInUserfeedback(false);
        setIsInSupport(false);
    }

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .sendForm('service_q14rix5', 'template_y9irn54', form.current, {
                publicKey: 'd5fZ6TQGQ3hH61o9G',
            })
            .then(
                () => {
                    setFeedBackSuccess(true);
                    setFeedbackMessage('Thank you for your feedback!');
                },
                (error) => {
                    setFeedBackSuccess(false);
                    setFeedbackMessage(error.text);
                },
            );
    };

    // support tab system

    const [activeTab, setActiveTab] = useState(1);

    // Function to change the active tab

    const selectTab = (tabIndex) => {
        setActiveTab(tabIndex);
    };

    const cancel = () => {
        reset();
        setIsInTabs(true);
    }

    const tabs = [
        {
            id: 1, name: "Interacting with the Map",
            content: "<h2>Interacting with the Map</h2><p> Welcome to our interactive map! We want to ensure you have the best experience navigating through this landscape.Here are some tips on how you can explore and interact with the map using your mouse and keyboard.</p><h3>Pan the Camera</h3><p>Need to move around the map? It’s simple! To pan the camera left, right, forward, or backward, just hold down the left mouse button and drag the map in the direction you want to go. It’s like sliding a piece of paper across your desk.</p><h3>Rotate the Camera</h3><p>Want to get a different perspective? Rotating the camera gives you a fresh view of the landscape. You have a couple of options for this:</p><ul><li><b>Option 1:</b> Hold down the right mouse button and drag. This will rotate the map around the point where you initially right-clicked. It’s as if you’re swiveling your view around a central point.</li><li><b>Option 2:</b> Hold down the CTRL key on your keyboard. Then, similar to panning, hold down the left mouse button and drag to rotate the map. This also rotates around the point where you first clicked, giving you a dynamic view of the terrain.</li></ul><h3>Zoom In and Out</h3><p>Getting a closer look at specific areas or zooming out to see the bigger picture is easy too:</p><ul><li>Use your mouse scroll wheel to zoom in and out. Wherever your mouse pointer is, that’s where the zoom will focus. It’s like looking through a magnifying glass and adjusting the zoom on the fly.</li><li>Double left-click on any point on the map to zoom directly into that location. This method is great for quickly focusing on a specific area.</li></ul><h3>On-Screen Navigation Controls</h3><p>If you prefer on-screen controls, we’ve got you covered. Click the green controls button located at the bottom right of the screen to open the navigation panel. Here’s what you can do with these controls:</p><ul><li><b>Bearing Slider:</b> Rotate the map horizontally around its center point. It’s perfect for changing your view direction without altering your position.</li><li><b>Pitch Slider:</b> Rotate the map vertically. This gives you an elevated view or a ground-level perspective of the landscape.</li><li><b>Zoom Buttons:</b> Click these to zoom in and out towards the center point of the map. These buttons provide precise control over your zoom level.</li></ul><p>We hope these tips help you navigate the map with ease and make your exploration enjoyable. Happy mapping!</p>"
        },
        {
            id: 2, name: "Saving Files",
            content: "<h2>Saving and Loading Files</h2><h3>Save Your Work</h3><p>We know how important your work is, and saving it should be a breeze. Here’s how you can do it effortlessly:</p><p>To save your current map, simply click on the <b>Save</b> button located at the top left of the menu. A prompt will appear, asking you to enter a filename. Choose a name that best describes your map, and hit enter. Now, sit back and relax as your map gets saved. In just a moment, your work is securely stored, ready for future use. It’s that easy!</p>"
        },
        {
            id: 3, name: "Loading Files",
            content: "<h2>Load Your Maps</h2><p>Ready to dive back into one of your saved maps? Loading files is just as simple and efficient:</p><p>Click on the <b>Load</b> button at the top left of the menu. You’ll be greeted with a display of all your available maps, neatly organized for your convenience. Browse through your collection, select the map you wish to open, and click <b>Open</b>. In an instant, your chosen map will be ready, right where you left off. It's like magic!</p><p>We hope these features make your experience seamless and enjoyable. Happy mapping!</p>"
        },
        {
            id: 4, name: "Your User Account",
            content: "<h2>User Account Information</h2><h3>Log In</h3><p>Accessing your personal maps and settings is just a few clicks away. Here’s how to log in:</p><ul><li>Click the <b>User</b> icon located at the top left of the menu.</li><li>You will be prompted to log in. Enter your username and password in the login screen.</li><li>Once you’ve entered your credentials, you will be redirected to the map, and your personal baseline map data will be loaded, ready for you to explore.</li></ul><h3>Log Out</h3><p>When you’re done with your session, logging out is quick and easy:</p><ul><li>While logged in, click the <b>User</b> icon at the top left of the menu.</li><li>You will see a <b>Sign Out</b> button. Click that, and you will be signed out of the session and redirected to the Public map.</li></ul><h3>Reset Password</h3><p>For security reasons or simply to change your password, follow these steps to reset it:</p><ul><li>Click the <b>User</b> icon in the top left corner.</li><li>You will see a <b>Settings</b> button. Click it to be directed to the settings panel.</li><li>On the left-hand side of the settings panel, there is a <b>Reset Password</b> option. Click on it, and you will be redirected to the Reset Password Page.</li><li>Once there, enter your current password and then your new preferred password. Confirm the changes, and you’re all set!</li></ul><p>We hope these instructions help you navigate your account with ease. If you have any issues, don’t hesitate to reach out for support. Happy mapping!</p>"
        },
        {
            id: 5, name: "Trouble Shooting",
            content: "<h2>Troubleshooting Advice</h2><h3>Map Not Loading</h3><p>If your map isn’t loading, here are a few steps to try:</p><ul><li>Check your internet connection. A stable connection is essential for loading the map data.</li></ul><h3>Lost Account Information</h3><p>If you’ve lost your account information, don’t worry! Please contact our support team at <a href='mailto:developer@harrier.land'>developer@harrier.land</a> for assistance. We’re here to help you recover your account.</p><h3>Encountering Other Issues?</h3><p>If you encounter any other issues, we’re here to help. Please use the contact form to get in touch with us. To access this:</p><ul><li>Navigate to <b>User Settings</b>. You can find the User Settings by clicking on the <b>User</b> icon located at the top left corner of the menu.</li><li>Click on the <b>User Feedback</b> button within the settings panel.</li></ul><p>Fill out the form with the details of the issue you’re experiencing, and our support team will get back to you as soon as possible.</p><p>We hope these tips help you resolve any problems quickly. Happy mapping!</p>"

        },
        {
            id: 6, name: "Security & Privacy",
            content: "<h2>Security and Privacy</h2><p>Your security and privacy are our top priorities. We are committed to protecting your personal information and ensuring your data is secure.</p><h3>Privacy Policy and Terms and Conditions</h3><p>For detailed information on how we handle your data, please refer to our Privacy Policy and Terms and Conditions. You can find these documents in the top left of the main toolbar. Simply click on the <b>User</b> icon, and you will see links to both the Privacy Policy and Terms and Conditions.</p><h3>Data Protection</h3><p>We use advanced security measures to protect your data from unauthorized access, alteration, disclosure, or destruction. This includes encryption, firewalls, and secure server facilities.</p><h3>User Privacy</h3><p>Your personal information is stored securely and used only to enhance your experience with our services. We do not sell or share your data with third parties without your explicit consent, except as required by law.</p><h3>Account Security</h3><p>We recommend using a strong, unique password for your account and changing it regularly. Avoid sharing your password with anyone and log out of your account when using shared or public devices.</p><h3>Contact Us</h3><p>If you have any questions or concerns about your privacy or the security of your data, please do not hesitate to contact us. Use the contact form available in the <b>User Settings</b> under the <b>User Feedback</b> button, or email us directly at <a href='mailto:developer@harrier.land'>developer@harrier.land</a>.</p><p>We are dedicated to maintaining a secure environment for our users. Thank you for trusting us with your information.</p>"
        }
    ];

    return (
        <>
            <MobileView>
                <div className='settingsMobile'>
                    <div className="settingMobile_inner_leftMenu">
                        <button onClick={openAccountSettings}
                            className="setting_menu_button_mobile">
                            <IoKeyOutline className="leftMenuIcons" /> Reset Password</button>
                        <button onClick={openSupport}
                            className="setting_menu_button_mobile">
                            <TbFolderQuestion className="leftMenuIcons" /> Support</button>
                    </div>
                </div>

                {isInAccountSettings ? (
                    <div className="AccountSettingsMobile">
                        <div className="AccountSettingInnerMobile">
                            <h2>{userEmail}</h2>
                        </div>
                    </div>
                ) : (
                    null
                )}
            </MobileView>

            <BrowserView>
                <div className='settings'>
                    <div className="setting_inner_leftMenu">
                        <h2>Account</h2>
                        <div>
                            <button onClick={cancel}
                                className={`setting_menu_button ${isInTabs ? 'active' : ''}`}>
                                <HiDevicePhoneMobile className="leftMenuIcons" /> Dashboard</button>
                        </div>
                        <div>
                            <button onClick={openAccountSettings}
                                className={`setting_menu_button ${isInAccountSettings ? 'active' : ''}`}>
                                <IoKeyOutline className="leftMenuIcons" /> Reset Password</button>
                        </div>
                        <div>
                            <button onClick={openUserfeedback}
                                className={`setting_menu_button ${isInUserfeedback ? 'active' : ''}`}>
                                <VscFeedback className="leftMenuIcons" /> User Feedback</button>
                        </div>
                        <div>
                            <button onClick={openSupport}
                                className={`setting_menu_button ${isInSupport ? 'active' : ''}`}>
                                <TbFolderQuestion className="leftMenuIcons" /> Support</button>
                        </div>
                    </div>
                    {isInTabs ? (
                        <div className='settings_inner'>
                            <h2>{userEmail}</h2>
                            <div>
                            </div>
                            <div className="settings__container_one">
                                <div className='settings__container__content__item__content'>
                                    <div class="settings_inner_container">
                                        <div class="square" onClick={openAccountSettings}>
                                            <p className="settings_inner_container_Header">
                                                <IoKeyOutline className="leftMenuIcons" />
                                                Reset Password
                                            </p>
                                        </div>
                                        <div class="square" onClick={openUserfeedback}>
                                            <p className="settings_inner_container_Header">
                                                <VscFeedback className="leftMenuIcons" />
                                                User Feedback
                                            </p>
                                        </div>
                                        <div class="square" onClick={openSupport}>
                                            <p className="settings_inner_container_Header">
                                                <TbFolderQuestion className="leftMenuIcons" />
                                                Support
                                            </p>
                                        </div>
                                        <div class="square" style={{
                                            backgrouindColor: 'white', opacity: '0.4', pointerEvents: 'none'
                                        }} onClick={openSupport}>
                                            <p className="settings_inner_container_Header">
                                                {/* <TbCube3dSphere className="leftMenuIcons" /> */}
                                                Harrier Air
                                            </p>
                                            <p  
                                                className="settings_inner_container_Header"
                                                style={{
                                                    fontSize: '10px',
                                                    marginTop: '60px',
                                                    // color: 'red'
                                                }}>
                                                Coming Soon
                                            </p>
                                        </div>
                                        <div className="settings__container_five_left">
                                            <p className="settings__container_five_left_header">
                                                Latest Update Notes
                                            </p>
                                            We have made several enhancements and fixes to improve your experience. The thumbnail loading functionality has been optimized to activate only upon clicking the load menu, ensuring efficient performance. We added a verification step and a response check to guarantee thumbnails load correctly.
                                            <p />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="settings__container_two">
                                <div className='settings__container__content__item__content'>
                                    <div class="settings_inner_container">
                                        <div class="squareSkylark">
                                            <p className="settings_inner_container_Header">Harrier Land App
                                            </p>
                                        </div>
                                        <div class="square" style={{ opacity: '0', pointerEvents: 'none' }} onClick={openSupport}>
                                            <p className="settings_inner_container_Header">
                                                <TbFolderQuestion className="leftMenuIcons" />
                                                Support
                                            </p>
                                        </div>
                                        <div class="square" style={{ opacity: '0', pointerEvents: 'none' }} onClick={openSupport}>
                                            <p className="settings_inner_container_Header">
                                                <TbFolderQuestion className="leftMenuIcons" />
                                                Support
                                            </p>
                                        </div>
                                        <div class="square" style={{ opacity: '0', pointerEvents: 'none' }} onClick={openSupport}>
                                            <p className="settings_inner_container_Header">
                                                <TbFolderQuestion className="leftMenuIcons" />
                                                Support
                                            </p>
                                        </div>
                                        <div class="square" style={{ opacity: '0', pointerEvents: 'none' }} onClick={openSupport}>
                                            <p className="settings_inner_container_Header">
                                                <TbFolderQuestion className="leftMenuIcons" />
                                                Support
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* <div className="settings__container_three">
                                <div className='settings__container__content__item__content'>
                                    <div className='settings__container__content__item__content'>
                                        <div class="settings_inner_container">
                                            <div class="banner_updates" style={{ backgroundPositionY: '-450px', backgroundSize: '100%', backgroundImage: `url(${banner})` }}>
                                                <p className="banner_updates_header">
                                                    Harrier for Authorities
                                                </p>
                                                <p className="banner_updates_subheader">
                                                    Subheading appears about banner.
                                                </p>
                                                <button className="banner_updates_button" onClick={() => window.open('https://harrier.land/', '_blank')}>
                                                    Learn More
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* <div className="settings__container_four">
                                <div className='settings__container__content__item__content'>
                                    <div className='settings__container__content__item__content'>
                                        <div class="settings_inner_container">
                                            <div class="square_updates">
                                                <p className="settings_inner_container_Headersquare_updates">
                                                    Latest Update Notes
                                                </p>
                                            </div>
                                            <div class="square_updates">
                                                <p className="settings_inner_container_square_updates">
                                                    A new user interface now displays the progress and completion status of thumbnail loading, complete with a loading indicator for better clarity.
                                                </p>
                                            </div>
                                            <div class="square_updates">
                                                <p className="settings_inner_container_square_updates">
                                                    The conditional UI issues related to thumbnail loading have also been resolved. Additionally, the authentication button has been updated to display “Profile” for clearer navigation.
                                                </p>
                                            </div>
                                            <div class="square_updates">
                                                <p className="settings_inner_container_square_updates">We have streamlined the About section with full stylings, and applied complete styling to the logo for a polished look.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    ) : (
                        null
                    )}

                    {isInAccountSettings ? (
                        <>
                            <BrowserView>
                                <div className="AccountSettings">
                                    <div className="AccountSettingInner">
                                        <h2>{userEmail}</h2>
                                        To reset your password, please follow the instructions below:<br /><br />
                                        1. <b>Click the Reset Password Button:</b><br />
                                        Click the "Reset Password" button provided below to navigate to the password reset page. This button will direct you to the secure page where you can begin the password reset process.<br /><br />
                                        2. <b>Enter Your Current Password:</b><br />
                                        On the reset password page, you will be prompted to enter your current password. This step is essential for verifying your identity and ensuring the security of your account.<br /><br />
                                        3. <b>Set Your New Password:</b><br />
                                        After entering your current password, you will have the option to set a new preferred password. Make sure to choose a strong and unique password that you haven't used before. A strong password typically includes a combination of uppercase and lowercase letters, numbers, and special characters.<br /><br />
                                        4. <b>Confirm the Changes:</b><br />
                                        Once you have entered your new password, confirm the changes, and you’re all set!<br /><br />
                                        <div className="changePasswordButton" onClick={goToChangePasswordPage}>
                                            <button className="changePasswordButtonInner">Reset Password</button>
                                        </div>
                                    </div>
                                </div>
                            </BrowserView>
                        </>
                    ) : (
                        null
                    )}

                    {/* {isInUsers ? (
                        <BrowserView>
                            <div className="AccountSettings">
                                <div className="AccountSettingInner">
                                    <h2>{userEmail}</h2>
                                    <div className="AccountSettingsUser">
                                        {ulist.map((user) => (
                                            <div className="AccountSettingsUserInner">
                                                <div className="AccountSettingsUserDetails">
                                                    <div className="AccountSettingsUserDetailsInner">
                                                        <div className="AccountSettingsUserDetailsName">{user.data.name}</div>
                                                        <div className="AccountSettingsUserDetailsEmail">{user.data.username}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </BrowserView>
                    ) : (
                        null
                    )} */}

                    {isInSavedFiles ? (
                        <div className="AccountSettings">
                            <div className="AccountSettingInner">
                                <h2>{userEmail}</h2>
                                Saved Files
                                <div className="AccountSettingsbuttons">
                                    <button className="AccountSettingsButtonCancel" onClick={cancel} type="button">Menu</button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        null
                    )}

                    {isInSharedFiles ? (
                        <div className="AccountSettings">
                            <div className="AccountSettingInner">
                                <h2>{userEmail}</h2>
                                Shared Files
                                <div className="AccountSettingsbuttons">
                                    <button className="AccountSettingsButtonCancel" onClick={cancel} type="button">Menu</button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        null
                    )}

                    {isInInstructions ? (
                        <div className="AccountSettings">
                            <div className="AccountSettingInner">
                                <h2>{userEmail}</h2>
                                Instructions
                                <div className="AccountSettingsbuttons">
                                    {/* <button className="AccountSettingsButtonCancel" onClick={cancel} type="button">Menu</button> */}
                                </div>
                            </div>
                        </div>
                    ) : (
                        null
                    )}

                    {isInUserfeedback ? (
                        <BrowserView>
                            <div className="AccountSettings">
                                <div className="AccountSettingInner">
                                    <h2>{userEmail}</h2>
                                    Let us know your thoughts

                                    {feedBackSuccess ? (
                                        <div className="feedbackSuccess">{feedbackMessage}</div>
                                    ) : (
                                        <div>
                                            <form ref={form} onSubmit={sendEmail} className="feedbackForm">
                                                <input placeholder="Name" type="text" name="user_name" className="feedbackFormName" />
                                                <input placeholder="Email" type="email" name="user_email" className="feedbackFormEmail" />
                                                <textarea placeholder="Message" name="message" className="feedbackFormMessage" />
                                                <input type="submit" value="Send" className="feedbackFormSubmit" />
                                            </form>
                                            <div className="feedbackSuccess">{feedbackMessage}</div>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </BrowserView>
                    ) : (
                        null
                    )}

                    {isInSupport ? (
                        <div className="AccountSettings">
                            <div className="AccountSettingInner">
                                <h2>{userEmail}</h2>
                                <div className="AccountSettingsbuttons">
                                    {/* <button className="AccountSettingsButtonCancel" onClick={cancel} type="button">Menu</button> */}
                                </div>
                                <div className="Tabs">
                                    <div className="TabList">
                                        {tabs.map(tab => (
                                            <div
                                                key={tab.id}
                                                className={`TabItem ${activeTab === tab.id ? 'active' : ''}`}
                                                onClick={() => selectTab(tab.id)}
                                            >
                                                {tab.name}
                                            </div>
                                        ))}
                                    </div>
                                    <div className="TabContent">
                                        <div dangerouslySetInnerHTML={{ __html: tabs.find(tab => tab.id === activeTab)?.content }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (null
                    )}

                </div>
            </BrowserView>
        </>
    );
}


export default SettingsPanel;
